import { Camera } from 'domain/camera'
import { CameraCapability } from 'enums/camera-capability'

export const emptyCamera: Camera = {
  id: '',
  clientId: '',
  httpPort: 80,
  ipAddress: '',
  isHttps: false,
  name: '',
  username: '',
  isActive: true,
  streamPath: '',
  model: {
    id: '',
    name: '',
    brand: '',
    capabilities: CameraCapability.LPR,
  },
  speedLimit: undefined,
  address: '',
  latitude: undefined,
  longitude: undefined
}
